<style>
  #MonthPickerInput{
    position: absolute;
    z-index: 2;
    pointer-events: none;
  }

  #MonthPickerInput:not(.open) > *{
    opacity: 0 !important;
    pointer-events: none !important;
  }

  #MonthPickerInput #backdrop{
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    pointer-events: auto;
  }

  #pickerContent{
    outline: none;
    pointer-events: auto;
    width: 260px;
    position: absolute;
    top: 100%;
    top: calc(100% + 5px);
    background: #fff;
    border-radius: 3px;
    overflow: hidden;
    box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.2);
    z-index: 5;
  }

  #yearWrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5em;
  }
  #yearWrapper input{
    font-size: 1.1rem;
    letter-spacing: 0.05em;
    border: none;
    outline: none;
    background: transparent;
    min-width: 0;
    width: 60px;
    text-align: center;
    appearance: none;
    -moz-appearance: textfield;
  }
  #yearWrapper input::-webkit-inner-spin-button,
  #yearWrapper input::-webkit-outer-spin-button{
      -webkit-appearance: none;
      margin: 0;
  }
  #yearWrapper button{
    background: transparent;
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    color: #555;
  }

  #yearWrapper button:disabled{
      opacity: 0.3;
      pointer-events: none;
  }

  #monthsWrapper{
    display: flex;
    flex-wrap: wrap;
    border-top: 1px solid #e8e8e8;
  }
  #monthsWrapper > button{
    font-size: 0.68rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 33.333%;
    height: 40px;
    position: relative;
    color: #333;
    background: transparent;
    border: none;
    outline: none;
  }
  #monthsWrapper > button.active{
    background: #ececec;
  }

  #monthsWrapper > button span{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5em;
  }

  #monthsWrapper > button:disabled{
    background: transparent;
    opacity: 0.4;
    pointer-events: none;
  }
</style>

<template>
    <div id="MonthPickerInput" :class="{'open': open}">
        <div id="backdrop" @click="hide" />
        <div id="pickerContent" tabindex="0">
          <div id="yearWrapper" class="d-flex align-items-center justify-content-between">
            <button type="button"
                :disabled="selectedYear <= minYear"
                @click="selectedYear = selectedYear - 1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
            </button>
            <input type="number" :value="selectedYear" @input="onYearInputChanged($event)">
            <button type="button"
                :disabled="maxYear !== null && selectedYear >= maxYear"
                @click="selectedYear = selectedYear + 1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
            </div>
            <div id="monthsWrapper">
              <button type="button" v-for="(month, index) in months"
                :class="{'active': selectedMonth === index}"
                :key="index"
                @click="selectedMonth = index"
                :disabled="(selectedYear === maxYear && index > maxMonth) || (selectedYear === minYear && index < minMonth)">
                <span>{{ month }}</span>
              </button>
            </div>
        </div>
    </div>
</template>

<script>
    let lastFocused;
    export default {
        name: 'MonthPickerInput',
        props: {
            value: Date | String,
            max: Date | String,
            min: Date | String,
        },
        mounted(){
            if(this.value){
                const date = new Date(this.value);
                this.selectedYear = date.getFullYear();
                this.selectedMonth = date.getMonth();
            }

            if(this.max){
                const maxDate = new Date(this.max);
                this.maxYear = maxDate.getFullYear();
                this.maxMonth = maxDate.getMonth();
            }

            if(this.min){
                const minDate = new Date(this.min);
                this.minYear = minDate.getFullYear();
                this.minMonth = minDate.getMonth();
            }
        },
        data: function(){
            return {
                open: false,
                months : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
                selectedYear: new Date().getFullYear(),
                selectedMonth: null,
                maxYear: null,
                maxMonth: null,
                minYear: 0,
                minMonth: null,
            };
        },
        watch: {
            selectedYear(){
                this.emitNewValue()},
            selectedMonth(){
                this.emitNewValue()
            }
        },
        methods: {
            hide(){
                lastFocused.focus();
                this.open = false;
            },
            show(){
                lastFocused = document.activeElement;
                window.onkeyup = e => {
                if(e.keyCode === 27)
                    this.hide();
                }
                this.open = true;
                setTimeout(() => {
                    var content = this.$el.querySelector("#pickerContent");
                    if(content) content.focus();
                });
            },
            onYearInputChanged(e){
                const value = parseInt(e.target.value);
                if(this.maxYear && value > this.maxYear){
                    setTimeout(() => {
                        e.target.value = this.maxYear;
                        this.selectedYear = this.maxYear;
                    }, 2000);

                    return false;
                }
                else if(this.minYear && value < this.minYear){
                    setTimeout(() => {
                        e.target.value = this.minYear;
                        this.selectedYear = this.minYear;
                    }, 2000);
                    return false;
                }

                this.selectedYear = value;
            },
            emitNewValue(){
                this.$emit('input', new Date(`7 ${this.months[this.selectedMonth]} ${this.selectedYear}`));
            }
        }
    };
</script>
